import * as React from 'react';
import { clsx } from 'clsx';

import { IPaginationOption } from '../../types/pagination';

import * as style from './Pagination.css';

export interface IPaginationProps {
  value: number;
  options: IPaginationOption[];
  onChange: (value: number) => void;
}

export const Pagination: React.FC<IPaginationProps> = props => {
  const { value: currentValue, options, onChange } = props;

  const handleClick = React.useCallback(
    (value: number) => (e: React.SyntheticEvent) => {
      e.preventDefault();

      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  return (
    <div className={style['container']}>
      <ul className={style['list']}>
        {options.map(({ value, url, label }, i) => {
          const isActive = currentValue === value;

          return (
            <li
              key={value}
              data-testid={`PaginationItem/${i}-${isActive ? 'Active' : 'Inactive'}`}
              className={clsx(style['item'], isActive && style['item--current'])}
            >
              <a href={url} data-testid={`PaginationItemLink/${i}`} onClick={handleClick(value)}>
                {label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
